import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchCustomTheme } from 'redux/themes/actions';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';
import { animatedBg } from './animated-backgrounds';
import './AnimatedBackgroundSelector.css';

const AnimatedBackgroundSelector = (props) => {
  const { me, patchCustomTheme, setCustomMode } = props;
  const customThemeId = me && me.custom_theme && me.custom_theme.id;
  const { t } = useTranslation();

  return (
    <div className="animated-background-selector__component">
      {animatedBg &&
        animatedBg.map((item, index) => {
          return (
            <React.Fragment key={index.toString()}>
              <ProFeaturePlaceholder
                placeholderContent={
                  <div>
                    {t("You can use this background on the PRO plan.")}
                  </div>
                }
                proLabel={item.pro}
                locked={
                  me &&
                  me.subscription &&
                  me.subscription.billing_plan.title === 'Starter' &&
                  item.pro
                }
              >
                <div
                  className={`animated-bg-item ${
                    item.bgName ===
                    (me && me.custom_theme.background_animated_style)
                      ? 'active'
                      : ''
                  }`}
                  onClick={() => {
                    if(me.theme) { setCustomMode(); }
                    const form = new FormData();
                    form.append('background_animated_style', item.bgName);
                    form.append('background_style', '');
                    form.append('background_image', '');
                    patchCustomTheme(customThemeId, form);
                  }}
                  role="button"
                >
                  <img src={item.prevIcon} />
                </div>
                <div className="text">{item.bgName}</div>
              </ProFeaturePlaceholder>
            </React.Fragment>
          );
        })}
    </div>
  );
};

AnimatedBackgroundSelector.propTypes = {
  me: PropTypes.object,
  patchCustomTheme: PropTypes.func.isRequired,
  setCustomMode: PropTypes.func.isRequired,
};

AnimatedBackgroundSelector.defaultProps = {
  me: null,
};

const mapStateToProps = (state) => ({
  me: state.usersReducer.me,
});

const mapDispatchToProps = {
  patchCustomTheme,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnimatedBackgroundSelector);
